/**
 * 选择地区学校，filter弹出框
 * 
 * @Author: Focci
 * @Date: 2023-07-24 15:55:53
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-24 15:55:53
 */

import PropTypes from 'prop-types'
import CustomDialog from '@comp/dialog/CustomDialog'
import ActionButtons from '@comp/form/ActionButtons'
import { useTranslations } from 'next-intl'
import { CircularProgress } from '@comp/material'
import { useMemo } from 'react'
import { getCount } from '@lib/utils'

export default function SearchDialog({
  children,
  loading = false,
  isValidating = false,
  disabled = false,
  showAction = true,
  actionClassName = 'mx-[0.78rem] w-full',
  count,
  onReset = () => {},
  onConfirm = () => {},
  actionButtonProps = {},
  ...dialogProps
}) {
  const ts = useTranslations('search')
  const confirmLabel = useMemo(() => {
    const statistic = /\d+/.test(count) ? `(${getCount(count)})` : ''
    return `${ts('search')}${statistic}`
  }, [count, ts])

  return (
    <CustomDialog
      fullScreen
      scroll="paper"
      subtile={false}
      action={showAction ? (
        <div className={actionClassName}>
          <ActionButtons 
            onCancel={onReset}
            onConfirm={onConfirm}
            confirmLabel={confirmLabel}
            disabled={disabled || loading}
            {...actionButtonProps}
          />
        </div>
      ) : null}
      {...dialogProps}
    >
      <div className="flex min-h-full relative">
        {children}
        {isValidating && (
          <div 
            className="
              absolute inset-0 bg-white/0 z-10 flex 
              items-center justify-center
            "
          >
            <CircularProgress size={30} />
          </div>
        )}
      </div>
    </CustomDialog>
  )
}

SearchDialog.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  isValidating: PropTypes.bool,
  disabled: PropTypes.bool,
  showAction: PropTypes.bool,
  actionClassName: PropTypes.string,
  count: PropTypes.number,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
}
